// @flow
import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  getExemptionCertificates,
  getExemptionCertificateAttachment,
  getExposureZones,
} from 'src/redux/actions/exemptionCertificates/exemptionCertificates'

const withExemptionCertificates = <P>(WrappedComponent: React.ComponentType<P>) => {
  class WithExemptionCertificatesComponent extends React.Component<P> {
    render() {
      return <WrappedComponent {...this.props} />
    }
  }
  const mapStateToProps = ({ exemptionCertificates }) => ({ exemptionCertificates })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getExemptionCertificates: data => dispatch(getExemptionCertificates.request(data)),
    getExemptionCertificateAttachment: data => dispatch(getExemptionCertificateAttachment.request(data)),
    getExposureZones: data => dispatch(getExposureZones.request(data)),

  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(WithExemptionCertificatesComponent))
}

export default withExemptionCertificates

